module.exports = "<div id=\"circular-progress-wrapper\">\n  <circular-progress></circular-progress>\n</div>\n"